export default "__VITE_ASSET__CZRb7pV___"